<template>
  <div class="flex flex-row mx-auto product-icons">

    <div class="product-icon">
      <form action="/customer/product/save" method="post" class="custom save-product-form"
            @submit.prevent="submitSave"
            style="display:inline-block;margin:0;">

        <button class="product-icon save-product-trigger" type="submit">
                    <span class="icon tooltip" :class="{ saved: isSaved }">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="-1.5 0 35 32" v-bind:svg-inline="''" v-bind:class="'icon-icons/we_save-icon'" v-show="!saving" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M23.6 2c-3.363 0-6.258 2.736-7.599 5.594C14.659 4.736 11.764 2 8.4 2 3.763 2 0 5.764 0 10.401c0 9.433 9.516 11.906 16.001 21.232C22.131 22.365 32 19.533 32 10.401 32 5.764 28.237 2 23.6 2z"/></svg>

                        <span class="loader" v-show="saving">
                            <img :src="`${baseAssetUrl}/img/loader.gif`" aria-hidden="true" alt="Loading placeholder">
                        </span>
                        <span class="tooltiptext">
                            Favorite
                        </span>
                    </span>
        </button>
      </form>
    </div>

    <div class="product-icon">
      <div class="compare-button tooltip" :data-id="item.sku" data-type="new"
           @click.prevent="compare($event, item, product_type, 'add', iKey)">

        <svg width="16" height="10" viewBox="0 0 16 10" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'icon-icons/we_compare-icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M15.5 6.505a.5.5 0 010 1H9.71l1.341 1.323a.5.5 0 11-.702.712l-2.2-2.171-.002-.003-.003-.002c-.024-.025-.036-.055-.054-.082-.017-.027-.041-.052-.053-.081-.012-.031-.013-.064-.019-.096C8.012 7.074 8 7.045 8 7.013v-.006-.002c0-.053.015-.102.03-.15.003-.01.002-.02.006-.028a.489.489 0 01.136-.193l2.177-2.148a.5.5 0 11.702.712L9.727 6.505H15.5zM.5 3.179a.5.5 0 010-1h5.79L4.949.856a.5.5 0 11.702-.712l2.2 2.171.002.003.003.002c.024.025.036.055.054.082.017.027.041.052.053.081.012.031.013.064.019.096.006.031.018.061.018.092v.008a.488.488 0 01-.03.149c-.003.01-.002.02-.006.029a.489.489 0 01-.136.193L5.651 5.198a.5.5 0 11-.702-.712l1.324-1.307H.5z" fill="#6D6D6D" fill-rule="evenodd"/></svg>

        <span class="tooltiptext">
                    Compare
                </span>
      </div>
    </div>

    <div class="product-icon">
      <div class="social-button">
        <svg width="12" height="15" viewBox="0 0 12 15" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" v-bind:svg-inline="''" @click="openMail" v-bind:class="'icon-icons/we_share-icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><defs><path id="a" d="M.329.409h5.342v9.674H.33z"/></defs><g fill="none" fill-rule="evenodd"><g transform="translate(3 -.409)"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path d="M.83 3.608a.5.5 0 00.355-.149l1.323-1.34v7.464a.5.5 0 101 0V2.135L4.815 3.46a.5.5 0 10.712-.702L3.38.58a.499.499 0 00-.193-.136C3.172.44 3.157.44 3.142.435 3.098.423 3.055.408 3.008.408L3.006.41H3c-.028 0-.054.011-.08.015-.038.006-.074.008-.109.021-.025.011-.046.032-.07.047-.03.02-.065.033-.092.06 0 .001 0 .002-.002.003l-.003.002-2.17 2.2a.5.5 0 00.355.851" fill="#6D6D6D" mask="url(#b)"/></g><path d="M11.5 4.591H8.1a.5.5 0 000 1H11v8H1v-8h2.91a.5.5 0 000-1H.5a.5.5 0 00-.5.5v9a.5.5 0 00.5.5h11a.5.5 0 00.5-.5v-9a.5.5 0 00-.5-.5" fill="#6D6D6D"/></g></svg>

        <ul class="social-button-dropdown">
          <li>
            <a :href="mailtoUrl" style="color: #666;">
              Email
            </a>
          </li>

          <li class="mobile-only" v-if="canShareApi">
            <a @click.prevent="share" style="color: #666;">
              SMS
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div class="product-icon" v-if="this.product_type === 'used'">
      <form action="/customer/product/price-watch/save" method="post" class="custom save-product-price-watch-form"
            @submit.prevent="submitSavePriceWatch"
            style="display:inline-block;margin:0;">

        <button class="product-icon save-product-trigger" type="submit">
                    <span class="icon tooltip" :class="{ saved: isSavedPriceWatch }">
                        <svg width="9" height="16" viewBox="0 0 9 16" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'icon-icons/we_save-icon'" v-show="!saving" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M8.545 10.692c0 1.458-.918 3.222-3.78 3.384v1.242c0 .216-.18.414-.414.414a.419.419 0 01-.414-.414v-1.224c-1.584-.072-2.862-.702-3.744-1.584a.49.49 0 01-.162-.378.522.522 0 01.864-.396c.702.702 1.728 1.314 3.042 1.404V8.082C2.12 7.578.265 7.002.265 4.878c0-1.872 1.62-3.096 3.672-3.186V.414c0-.216.18-.414.414-.414.234 0 .414.198.414.414V1.71c1.332.09 2.376.576 3.168 1.332.108.09.198.234.198.396 0 .27-.234.504-.522.504-.126 0-.252-.036-.324-.126-.702-.702-1.548-1.044-2.52-1.152v4.518c1.872.522 3.78 1.188 3.78 3.51zm-7.2-5.868c0 1.278 1.188 1.728 2.592 2.124v-4.32c-1.476.072-2.592.954-2.592 2.196zm3.42 8.298c2.106-.144 2.7-1.404 2.7-2.358 0-1.494-1.26-2.034-2.7-2.448v4.806z" fill="#6D6D6D" fill-rule="nonzero"/></svg>

                        <span class="loader" v-show="saving">
                            <img :src="`${baseAssetUrl}/img/loader.gif`" aria-hidden="true" alt="Loading placeholder">
                        </span>
                        <span class="tooltiptext">
                            Price Watch
                        </span>
                    </span>
        </button>
      </form>
    </div>

    <div class="product-icon" v-if="this.product_type === 'used'">
      <form action="/customer/product/similar/save" method="post" class="custom save-product-price-watch-form"
            @submit.prevent="submitSaveSimilarAlert"
            style="display:inline-block;margin:0;">

        <button class="product-icon save-product-trigger" type="submit">
                    <span class="icon tooltip" :class="{ saved: isSavedSimilarAlert }">
                        <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'icon-icons/we_save-icon'" v-show="!saving" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M13.836 11.35l-.146-.184c-.274-.333-.56-.724-.858-1.174-.298-.45-.447-.915-.447-1.395V5.53c0-.665-.115-1.29-.344-1.871a4.798 4.798 0 00-.953-1.527 4.463 4.463 0 00-1.43-1.027A4.224 4.224 0 007.886.73a4.19 4.19 0 00-1.759.375 4.38 4.38 0 00-1.422 1.027c-.4.436-.716.944-.945 1.527a5.053 5.053 0 00-.345 1.87v3.068c0 .47-.156.923-.469 1.358a43.56 43.56 0 01-.865 1.167c-.234.313-.42.6-.557.858-.136.26-.146.512-.029.756.108.216.281.35.52.404.24.054.472.08.697.08h2.682c0 .695.244 1.287.733 1.777.489.489 1.08.733 1.774.733s1.285-.244 1.773-.733a2.42 2.42 0 00.733-1.776h2.741c.147 0 .352-.02.616-.059a.718.718 0 00.572-.426.733.733 0 00-.044-.734 6.7 6.7 0 00-.455-.652zM7.9 14.747c-.42 0-.78-.15-1.078-.448a1.471 1.471 0 01-.447-1.078h3.05c0 .42-.15.78-.448 1.078a1.467 1.467 0 01-1.077.448zm5.35-2.524H2.535c.049-.079.105-.162.168-.25l.184-.25c.283-.381.608-.838.974-1.372.367-.533.55-1.118.55-1.754V5.53c0-.528.088-1.023.264-1.483.176-.46.42-.86.733-1.203a3.514 3.514 0 011.107-.815c.425-.2.881-.3 1.37-.3.498 0 .96.1 1.385.3.425.201.794.473 1.107.815.313.342.56.744.74 1.203.181.46.271.955.271 1.483v3.067c0 .656.174 1.255.52 1.798a14.436 14.436 0 001.18 1.615c.06.073.113.144.162.213z" fill="#6D6D6D" fill-rule="nonzero"/></svg>

                        <span class="loader" v-show="saving">
                            <img :src="`${baseAssetUrl}/img/loader.gif`" aria-hidden="true" alt="Loading placeholder">
                        </span>
                        <span class="tooltiptext">
                            Receive alerts when similar products become available.
                        </span>
                    </span>
        </button>
      </form>
    </div>

  </div>
</template>

<script>
import CompareProducts from '../../CompareProducts';
import {
  apiUrls,
  createProductPriceWatchParams,
  createProductSaveParams,
  createProductSimilarAlertsParams
} from "../../data/OnLoginActionParams";
import axios from "axios";
import {notificationController} from "../../global/global_notifications";

export default {
  props: ['item', 'product_type', 'iKey'],
  data() {
    return {
      saving: false,
      baseAssetUrl: window.baseAssetUrl,
    }
  },
  computed: {
    isNewType() {
      return this.product_type === 'new';
    },
    userProducts() {
      if (this.isNewType) {
        return this.$store.getters['user/getNewProducts']
      } else {
        return this.$store.getters['user/getUsedProducts']
      }
    },
    productUrl() {
      return '/products/' + this.product_type + '/' + this.productId;
    },
    productId() {
      return this.item[this.isNewType ? 'sku' : 'machine_id'];
    },
    savedProduct() {
      if (this.isNewType){
        return this.$store.getters['user/getNewProductBySku'](this.productId)
      } else {
        return this.$store.getters['user/getUsedProductById'](this.productId)
      }
    },
    isSaved() {
      return this.savedProduct !== null;
    },
    isSavedPriceWatch() {
      return this.isSaved && this.savedProduct.price_alerts || false;
    },
    isSavedSimilarAlert() {
      return this.isSaved && this.savedProduct.similar_alerts;
    },
    mailtoUrl() {
      let item = this.item;

      let origin = window.location.origin;

      let url = 'mailto:?subject=',
        product_name = '',
        product_body = '',
        product_url = '';

      if (this.isNewType) {
        product_name = 'John Deere ' + item.model_number;
        product_body = 'I found this ' + product_name + ' at Western Equipment, Check it out.';
        product_url = origin + this.productUrl;
      } else {
        product_name = item.model_info;
        product_body = 'I found this ' + product_name + ' at Western Equipment, Check it out.';
        product_url = origin + this.productUrl;
      }

      // Add Subject
      url += product_name + ' is available at Western Equipment';

      // Add Body
      url += '&body=' + product_body + '%0D%0A%0D%0A' + product_url;

      return url;
    },
    mobileShare() {
      let item = this.item;

      let origin = window.location.origin;

      let sms = '',
        product_name = '',
        product_body = '',
        product_url = '';

      if (this.isNewType) {
        product_name = 'John Deere ' + item.model_number;
        product_body = 'I found this ' + product_name + ' at Western Equipment, Check it out. ';
        product_url = origin + this.productUrl;
      } else {
        product_name = item.model_info;
        product_body = 'I found this ' + product_name + ' at Western Equipment, Check it out. ';
        product_url = origin + this.productUrl;
      }

      // Add body
      sms += product_body + ' ' + product_url;

      return {
        title: product_name,
        text: product_body,
        url: product_url
      };
    },
    canShareApi() {
      return navigator.share;
    },
    isGuest() {
      return this.$store.getters['user/isGuest']
    },
    user() {
      return this.$store.getters['user/getUser']
    },
    analyticsData() {
      if (this.isNewType){

        let category = ""
        if (this.item.categories && this.item.categories.length){
          //detailed page
          for(let i = 0; i < this.item.categories.length; i++){
            if (this.item.categories[i].parents && this.item.categories[i].parents.length > 0){
              let cat = this.item.categories[i];
              category = `${cat.name} (${cat.parents[0].name})`;
              break;
            }
          }

          if (!category){
            category = this.item.categories[0].name

            if (this.item.categories[0].parents && this.item.categories[0].parents.length){
              category += ` (${this.item.categories[0].parents[0].name})`
            }
          }
        }

        if (!category){
          //this is for search
          category = this.item.category || ""
          if (this.item.subcategory) {
            category = `${this.item.subcategory} (${category})`
          }
        }

        return {
          equipmentType: 0,
          model: `John Deere ${this.item.model_number}`,
          stockNumber: undefined,
          sku: this.item.sku,
          categoryTitle: category,
          url: `${window.location.origin}/products/new/${this.productId}`
        }
      } else {
        return {
          equipmentType: 1,
          model: this.item.model_info,
          stockNumber: this.item.stock_number,
          sku: undefined,
          categoryTitle: this.item.category.label || this.item.category,
          url: `${window.location.origin}/products/used/${this.productId}`
        }
      }
    }
  },
  methods: {
    openMail() {
      window.open(this.mailtoUrl, '_parent');
    },
    submitSave() {
      if (this.isSaved) {
        this.removeSavedProduct();
      } else {
        this.saveProduct();
      }
    },
    submitSavePriceWatch() {
      if (this.isSavedPriceWatch) {
        this.removeSavedProductPriceWatch();
      } else {
        this.saveProductPriceWatch();
      }
    },
    submitSaveSimilarAlert() {
      if (this.isSavedSimilarAlert) {
        this.removeSavedProductSimilarAlert();
      } else {
        this.saveProductSimilarAlert();
      }
    },

    async updateSavedProduct(productUpdate) {
      if (this.isSaved && !productUpdate) {
        await this.$store.dispatch("user/removeProduct", {
          isNew: this.isNewType,
          id: this.productId
        })
      } else {
        await this.$store.dispatch("user/setProduct", {
          isNew: this.isNewType,
          product: productUpdate
        })

        if (this.isNewType){
          await this.$store.dispatch("analytics/onAddFavorite", this.analyticsData)
        } else {
          await this.$store.dispatch("analytics/onAddFavorite", this.analyticsData)
        }
      }
    },

    async saveProduct() {
      let _this = this

      if (!this.saving) {
        let data = {
          type: this.product_type,
          related_id: this.productId
        };
        this.saving = true;
        try {
          if (this.$store.getters["user/isGuest"]){
            window.openLogin(createProductSaveParams(data, function(response) {
              _this.updateSavedProduct(response.data.product)
            }, this.analyticsData));
          } else {
            let response = await axios.post(apiUrls.productSave, data)
            _this.updateSavedProduct(response.data.product)
          }
        } catch (e) {
          if (e.response && e.response.status === 401) {
            window.openLogin(createProductSaveParams(data, function(response) {
              _this.updateSavedProduct(response.data.product)
            }, this.analyticsData));
          } else {
            // Handle other errors (show error message or log the error)
            console.error("Error saving product:", e.response ? e.response.data : e.message);
            notificationController.errorMessage("An error occurred while saving the product. Please try again.");
          }
        } finally {
          this.saving = false;
        }
      }
    },

    async removeSavedProduct() {
      if (!this.saving && this.isSaved) {
        this.saving = true;
        try{
          await axios.delete(apiUrls.productDelete(this.product_type, this.savedProduct.id))
          if (this.isSaved){
            this.updateSavedProduct(false)
          }
        } finally {
          this.saving = false
        }
      }
    },

    async saveProductPriceWatch() {
      if (!this.isNewType && !this.saving) {
        this.saving = true;
        let _this = this;

        const data = {
          related_id: this.productId
        }

        try {
          if (this.$store.getters["user/isGuest"]){
            window.openLogin(createProductPriceWatchParams(data, function(response) {
              _this.updateSavedProduct(response.data.product)
            }, this.analyticsData));
          } else {
            let response = await axios.post(apiUrls.productPriceWatch, data)
            this.updateSavedProduct(response.data.product);
          }
        } catch (e) {
          if (e.response && e.response.status === 401) {
            window.openLogin(createProductPriceWatchParams(data, function(response) {
              _this.updateSavedProduct(response.data.product)
            }, this.analyticsData));
          } else {
            // Handle other errors (show error message or log the error)
            console.error("Error saving product:", e.response ? e.response.data : e.message);
            alert("An error occurred while saving the product. Please try again.");
          }
        } finally {
          this.saving = false
        }
      }
    },

    async removeSavedProductPriceWatch() {
      if (!this.saving && this.isSaved) {
        this.saving = true;

        try {
          let response = await axios.delete(apiUrls.deleteProductPriceWatch(this.savedProduct.id))
          this.updateSavedProduct(response.data.product);
        } finally {
          this.saving = false
        }
      }
    },

    async saveProductSimilarAlert() {
      if (!this.isNewType && !this.saving) {
        this.saving = true;
        const _this = this;

        const data = {
          type: this.product_type,
          related_id: this.productId
        }

        try {

          if (this.$store.getters["user/isGuest"]){
            window.openLogin(createProductSimilarAlertsParams(data, function(response) {
              _this.updateSavedProduct(response.data.product)
            }, this.analyticsData));
          } else {
            const response = await axios.post(apiUrls.productSimilarAlerts, data)
            this.updateSavedProduct(response.data.product)
          }
        } catch (e) {
          if (e.response && e.response.status === 401) {
            window.openLogin(createProductSimilarAlertsParams(data, function(response) {
              _this.updateSavedProduct(response.data.product)
            }, this.analyticsData));
          } else {
            // Handle other errors (show error message or log the error)
            console.error("Error saving product:", e.response ? e.response.data : e.message);
            alert("An error occurred while saving the product. Please try again.");
          }
        } finally {
          this.saving = false;
        }
      }
    },

    async removeSavedProductSimilarAlert() {
      if (!this.saving && this.isSaved) {
        this.saving = true;

        try {
          let response = await axios.delete(apiUrls.prodocutSimilarAlertsDelete(this.product_type,  this.savedProduct.id))
          this.updateSavedProduct(response.data.product);
        } finally {
          this.saving = false
        }
      }
    },
    /**
     * Redirect To Login
     *
     * Redirects to the customer login page
     * **/
    redirectToLogin() {
      window.location = window.location.origin + '/customer/login';
    },
    /**
     * Compare.
     *
     * Adds or removes a product from the compare box.
     *
     * @param e
     * @param item
     * @param type
     * @param method
     * @param index
     */
    compare(e, item, type, method, index = null) {
      item.type = type;
      if (method === 'add') {
        CompareProducts.addItem(item);
      } else {
        CompareProducts.removeItem(index);
      }
    },
    share() {
      if (this.canShareApi) {
        navigator.share({
          title: this.mobileShare.title,
          text: this.mobileShare.text,
          url: this.mobileShare.url,
        });
      }
    },
    checkForAuthPopupReady() {
      if (!window.openLogin && (this.isGuest || this.user)){
        this.saving = true
        setTimeout(this.checkForAuthPopupReady, 200)
      } else {
        this.saving = false
      }
    }
  },
  mounted() {
    this.checkForAuthPopupReady();
    this.$store.dispatch("user/getUserOnce", this.productId);
  }
}
</script>



// WEBPACK FOOTER //
// resources/js/Components/ProductSearch/ActionButtons.vue